const {
  select,
  find,
  findAll
} = DOM;

const Gallery = {
  fancyItems: [],
  showFancy(startIndex) {
    Fancybox.show([
      ...this.fancyItems,
    ], {
      Toolbar: {
        display: {
          left: [],
          right: ['close'],
        },
      },
      Thumbs: {
        type: "classic",
      },
      startIndex,
      mainClass: 'gallery-fancy-show',
    });
  },

  initGallery(element) {
    if (!element) return;

    const prevBtn = find(element, '[data-action="gallery.thumbs.prev"]');
    const nextBtn = find(element, '[data-action="gallery.thumbs.next"]');

    const galleryThumbs = find(element, '.m-gallery-thumbs');
    const galleryMain = find(element, '.m-gallery-main');

    if (!galleryThumbs || !galleryMain) {
      return;
    }

    const thumbsSlider = new Swiper(galleryThumbs, {
      slidesPerView: 4,
      spaceBetween: 10,
      freeMode: true,
      direction: 'horizontal',
      loop: false,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      // navigation: {
      //   nextEl: ".swiper-button-next",
      //   prevEl: ".swiper-button-prev"
      // },
      breakpoints: {
        768: {
          spaceBetween: 10,
          slidesPerView: 3,
          direction: 'vertical',
        },
      },
      on: {
        slideChange(e) {
          mainSlider.slideTo(e.activeIndex);
        }
      }
    });

    Array.from(findAll(galleryThumbs, '.swiper-slide')).forEach((el, i) => {
      el.addEventListener('click', (e) => {
        thumbsSlider.slideTo(i);
        if (el.dataset.action === 'thumbs.video') {
          this.showFancy(i)  
        }
      });
    });

    const mainSlider = new Swiper(galleryMain, {
      slidesPerView: 1,
      spaceBetween: 10,
      thumbs: {
        swiper: thumbsSlider,
      },
      breakpoints: {
        768: {
          spaceBetween: 20,
        },
      },
    });

    prevBtn.addEventListener('click', () => {
      mainSlider.slidePrev();
    });
    
    nextBtn.addEventListener('click', () => {
      if (mainSlider.isEnd) return;
      mainSlider.slideNext();
    });

    const id = element.dataset.sliderId || Date.now();
    if (typeof Sliders === 'undefined') {
      window.Sliders = { instances: {} };
    }
    Sliders.instances[id] = { main: mainSlider, thumbs: thumbsSlider };
  },

  bindFancyBox(slider) {
    const items = findAll(slider, '[data-fancybox]');
    const gallery = [];
    Array.from(items).forEach((item, index) => {
      item.addEventListener('click', (e) => {
        e.preventDefault(); 
        this.showFancy(index)  
      });

      const galleryItem = {
        src: item.getAttribute('href'),
      };

      if (item.dataset && item.dataset.fancyboxType) {
        galleryItem.type = item.dataset.fancyboxType;
      }

      if (item.dataset && item.dataset.fancyboxVideo) {
        try {
          galleryItem.video = JSON.parse(item.dataset.fancyboxVideo);
        } catch (error) {
          console.warn('Failed to parse data-fancybox-video', error);
        }
      }

      gallery.push(galleryItem);
    })
    this.fancyItems = gallery;
  },

  initAll() {
    const gallerySliders = select('.m-gallery', true);
    if (gallerySliders && gallerySliders.length > 0) {
      gallerySliders.forEach((slider) => {
        this.initGallery(slider);
        this.bindFancyBox(slider);
      });
    }
  },
};

export default Gallery;
